/*
 * @Description:
 * @Date: 2024-11-05 09:46:11
 */
export const getFirstLevelDomain = () => {
  const hostname = window.location.hostname;
  if (process.env.NODE_ENV === 'development') return hostname;
  const matches = /[^.]+\.[^.]+$/.exec(hostname);
  return matches ? matches[0] : hostname;
};
export const getFileNameByUrl = (url: string): string => {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const lastSlashIndex = pathname.lastIndexOf('/');
    const fileName = pathname.substring(lastSlashIndex + 1) || '下载文件';
    return decodeURIComponent(fileName);
  } catch (e) {
    throw new Error('Invalid URL');
  }
};
